module.exports = __webpack_public_path__ + "static/media/pic3.87187f44.jpg";